// utils/bumpPricing.ts — hitung bump fisik (pure, tanpa ongkir)
import type { FormBumpProduct } from '../types/forms/bump';

export interface BumpOption {
  productId: string;
  name: string;
  basePrice: number;
  addonPrice: number;
  label?: string;
  // Berat satuan (gram) dari Daftar Produk (products.attributes.weight). ×1 per bump.
  weightGrams: number;
}

export function buildBumpOptions(
  cfg: FormBumpProduct[] | undefined,
  rows: Array<{ id: string; name: string; basePrice?: number | null; price?: number | null; weightGrams?: number | null }>,
): BumpOption[] {
  const byId = new Map((cfg || []).map((b) => [b.productId, b]));
  return rows.map((r) => {
    const raw = byId.get(r.id);
    const base = Number(r.basePrice ?? r.price ?? 0) || 0;
    const addonRaw = Number(raw?.bumpPrice);
    return {
      productId: r.id,
      name: r.name,
      basePrice: base,
      addonPrice: addonRaw > 0 ? addonRaw : base,
      label: raw?.label || undefined,
      weightGrams: Number(r.weightGrams) > 0 ? Number(r.weightGrams) : 0,
    };
  });
}

export function bumpWeightGrams(opts: BumpOption[], selectedIds: string[]): number {
  return opts
    .filter((o) => selectedIds.includes(o.productId))
    .reduce((s, o) => s + (Number(o.weightGrams) > 0 ? Number(o.weightGrams) : 0), 0);
}

export function bumpTotals(opts: BumpOption[], selectedIds: string[]): { sum: number; discount: number } {
  let sum = 0;
  let discount = 0;
  for (const o of opts) {
    if (!selectedIds.includes(o.productId)) continue;
    sum += o.addonPrice;
    if (o.addonPrice < o.basePrice) discount += o.basePrice - o.addonPrice;
  }
  return { sum, discount };
}
